
import { Component, Prop, Vue } from "vue-property-decorator";
import { getDictItemList, delDictItem, sortDictType } from "@/api/api-basic";
import { objAny } from "@/common/common-interface";
import addDictionaryChild from "./components/add-dictionary-child.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-dictionary-child": addDictionaryChild
  }
})
export default class SystemConfigLog extends Vue {
  @Prop({ default: "" })
  private typePkId!: string;
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private privilege!: objAny;

  private formInline: objAny = {
    globalSearch: "",
    typePkId: "",
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private flagObj: objAny = {
    "0": i18n.t("regularText"),
    "1": i18n.t("disabled")
  };
  private total = 0;
  private loading = false;
  private itemData: objAny = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("dictionary.itemValue"),
      key: "itemValue",
      minWidth: 80,
      align: "center"
    },
    {
      title: i18n.t("dictionary.englishName"),
      key: "englishName",
      minWidth: 80,
      align: "center"
    },
    {
      title: i18n.t("dictionary.thName"),
      key: "thName",
      minWidth: 80,
      align: "center"
    },
    {
      title: i18n.t("dictionary.itemKey"),
      key: "itemKey",
      minWidth: 120,
      align: "center"
    },
    {
      title: i18n.t("dictionary.flag"),
      key: "flag",
      minWidth: 100,
      slot: "flag",
      align: "center"
    },
    {
      title: i18n.t("dictionary.remark"),
      key: "remark",
      minWidth: 180,
      align: "center"
    },
    {
      title: i18n.t("dictionary.modifyTime"),
      key: "modifyTime",
      minWidth: 160,
      align: "center",
      render: (h: Function, params: objAny) => {
        if (params.row.modifyTime) {
          return h(
            "div",
            this.$common.userDate(
              new Date(params.row.modifyTime),
              "yyyy-MM-dd HH:MM:SS"
            )
          );
        } else {
          return h("div", "");
        }
      }
    },
    {
      title: i18n.t("operation"),
      key: "resultDes",
      minWidth: 140,
      slot: "action",
      align: "center"
    }
  ];
  private addDictionaryChild: objAny = {};

  public goBackClick(): void {
    this.$emit("isShow", this);
    this.$emit("success");
  }

  public initData(data: objAny): void {
    this.formInline.typePkId = data.typePkId;
    this.itemData = data;
    this.queryClick();
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public addNewClick(): void {
    this.addDictionaryChild.open();
  }

  public openAddDictionary() {
    this.addDictionaryChild.open();
  }
  public updataItem(item: objAny) {
    this.addDictionaryChild.open(item);
  }
  public delItem(item: objAny): void {
    this.alldDelitem(item.pkid);
  }
  public makeItemUp(item: objAny, index: number): void {
    // this.$Message.error("接口开发中");
    if (index > 0) {
      const pkIds: number[] = [item.pkid];
      const itemData: objAny = this.tableList[index - 1];
      pkIds.push(itemData.pkid);
      this.subSort(pkIds);
    }
  }
  public makeItemDown(item: objAny, index: number): void {
    if (index < this.tableList.length - 1) {
      const itemData: objAny = this.tableList[index + 1];
      const pkIds: number[] = [itemData.pkid, item.pkid];

      this.subSort(pkIds);
    }
  }
  async subSort(pkIds: number[]): Promise<void> {
    const ret = await sortDictType({ pkIds: pkIds });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }
  async alldDelitem(id: string): Promise<void> {
    const ret = await delDictItem({ pkid: id });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getDictItemList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  mounted() {
    this.addDictionaryChild = this.$refs["addDictionaryChild"];
    // this.getTableList();
  }
}
